const initialState = [
  {
    name: 'Задания',
    active: false,
    link: 'task',
    icon: 'ico-m-tasks'
  },
  {
    name: 'Зачетка',
    active: false,
    link: 'reports',
    icon: 'ico-m-book'
  },
  {
    name: 'Питание',
    active: false,
    link: 'food',
    icon: 'ico-m-food'
  },
  {
    name: 'Вопросы',
    active: false,
    link: 'faq',
    icon: 'ico-m-faq'
  },
  {
    name: 'Фото',
    active: false,
    link: 'photos',
    icon: 'ico-photo'
  },
  {
    name: 'Чат',
    active: false,
    link: 'chats',
    icon: 'ico-chat'
  },
  {
    name: 'Новости',
    active: false,
    link: '',
    icon: 'ico-msg'
  },
	{
		name: 'Рейтинги',
		active: false,
		link: 'ratings',
		icon: 'ico-ratings'
	},
	{
		name: 'Сезоны',
		active: false,
		link: 'seasons',
		icon: 'ico-calendar'
	},
/*  {
    name: 'Партнеры',
    active: false,
    link: 'partners',
    icon: 'ico-users'
  },
  {
    name: 'Сезоны',
    active: false,
    link: 'seasons',
    icon: 'ico-calendar'
  },*/
]

export const menuList = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_MENU_LIST':
      return state.map((item, i) => {
        if (i === action.index) {
          item.active = true
        } else {
          item.active = false
        }
        return item
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// /var/www/build-health-2/src/reducers/menu.js